import React from "react";
import Heading from "../../components/Heading";

const SoftwareStackUse = () => {
  return (
    <div className="px-[1%] md:px-[6%] py-[3%] mb-[3%]">
      <div className="text-center mb-[5%] md:mb-[2%]">
        <Heading content="Technology We Expertise" />
        <p className=" text-[18px] text-left md:text-center px-[3%] m-[1%] font-[500] text-slate-800">
          Abscod, an IT consulting company, stays ahead of the curve by
          continually acquiring insights into both leading and emerging
          technologies. This approach allows us to proactively identify
          solutions that meet the ever-evolving needs of our clients.
        </p>
      </div>
      <div className=" grid lg:grid-cols-5 md:grid-cols-3 grid-cols-1 gap-5 mx-[25%]  md:mx-[7%]">
        <div className="w-48 h-44  text-white font-[900] bg-gradient-to-b from-[#326287] to-[#087dd6]  rounded-[12px] shadow-md  flex justify-center items-center px-2  text-center transition-transform duration-500 ease-in-out transform hover:scale-90">
          <h3 className="">SAAS DEVELOPMENT</h3>
        </div>
        <div className="- w-48 h-44  text-white font-[900] bg-gradient-to-b from-[#326287] to-[#087dd6]  rounded-[12px] shadow-md  flex justify-center items-center px-2  text-center transition-transform duration-500 ease-in-out transform hover:scale-90">
          <h3 className="">CRM DEVELOPMENT</h3>
        </div>
        <div className="- w-48 h-44  text-white font-[900] bg-gradient-to-b from-[#326287] to-[#087dd6]  rounded-[12px] shadow-md  flex justify-center items-center px-2  text-center transition-transform duration-500 ease-in-out transform hover:scale-90">
          <h3 className="">BI APPS DEVELOPMENT</h3>
        </div>
        <div className="- w-48 h-44  text-white font-[900] bg-gradient-to-b from-[#326287] to-[#087dd6]  rounded-[12px] shadow-md  flex justify-center items-center px-2  text-center transition-transform duration-500 ease-in-out transform hover:scale-90">
          <h3 className="">INTEGRATION DEVELOPMENT</h3>
        </div>
        <div className="w-48 h-44  text-white font-[900] bg-gradient-to-b from-[#326287] to-[#087dd6]  rounded-[12px] shadow-md  flex justify-center items-center px-2  text-center transition-transform duration-500 ease-in-out transform hover:scale-90">
          <h3 className="">DATABASE DEVELOPMENT</h3>
        </div>
        <div className=" w-48 h-44  text-white font-[900] bg-gradient-to-b from-[#326287] to-[#087dd6]  rounded-[12px] shadow-md  flex justify-center items-center px-2  text-center transition-transform duration-500 ease-in-out transform hover:scale-90">
          <h3 className="">PHP/MYSQL DEVELOPMENT</h3>
        </div>
        <div className=" w-48 h-44  text-white font-[900] bg-gradient-to-b from-[#326287] to-[#087dd6]  rounded-[12px] shadow-md  flex justify-center items-center px-2  text-center transition-transform duration-500 ease-in-out transform hover:scale-90">
          <h3 className="">HTML5 / CSS</h3>
        </div>

        <div className=" w-48 h-44  text-white font-[900] bg-gradient-to-b from-[#326287] to-[#087dd6]  rounded-[12px] shadow-md  flex justify-center items-center px-2  text-center transition-transform duration-500 ease-in-out transform hover:scale-90">
          <h3 className="">MAGENTO ECOMMERCE DEVELOPMENT</h3>
        </div>
        <div className=" w-48 h-44  text-white font-[900] bg-gradient-to-b from-[#326287] to-[#087dd6]  rounded-[12px] shadow-md  flex justify-center items-center px-2  text-center transition-transform duration-500 ease-in-out transform hover:scale-90">
          <h3 className="">MICROSOFT DEVELOPMENT</h3>
        </div>
        <div className="w-48 h-44  text-white font-[900] bg-gradient-to-b from-[#326287] to-[#087dd6]  rounded-[12px] shadow-md  flex justify-center items-center px-2  text-center transition-transform duration-500 ease-in-out transform hover:scale-90">
          <h3 className="">DRUPAL CMS DEVELOPMENT</h3>
        </div>
      </div>
    </div>
  );
};

export default SoftwareStackUse;
